import api from './api';

export type VeiculoTipo = 'PROPRIO' | 'TERCEIRO' | 'AGREGADO';

export interface Veiculo {
  id: string;
  placa: string;
  marca?: string | null;
  modelo?: string | null;
  ano?: number | null;
  cor?: string | null;
  renavam?: string | null;
  chassi?: string | null;
  rntrc?: string | null;
  uf?: string | null;
  tipo?: VeiculoTipo | null;
  capacidade_kg?: number | null;
  tara?: number | null;
  proprietario_nome?: string | null;
  proprietario_cpf_cnpj?: string | null;
  is_active: boolean;
}

export type VeiculoInput = Omit<Veiculo, 'id'>;

const ENDPOINT = '/industrializacao/veiculo';

const veiculoService = {
  async listar(filters: { tipo?: string; is_active?: boolean; search?: string } = {}): Promise<Veiculo[]> {
    const response = await api.get<Veiculo[]>(ENDPOINT, { params: filters });
    return response.data;
  },
  async ativos(): Promise<Veiculo[]> {
    const response = await api.get<Veiculo[]>(`${ENDPOINT}/ativos`);
    return response.data;
  },
  async buscarPorId(id: string): Promise<Veiculo> {
    const response = await api.get<Veiculo>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: VeiculoInput): Promise<Veiculo> {
    const response = await api.post<Veiculo>(ENDPOINT, data);
    return response.data;
  },
  async atualizar(id: string, data: Partial<VeiculoInput>): Promise<Veiculo> {
    const response = await api.put<Veiculo>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default veiculoService;
